// MultiPartHeader.js
function MultiPartApi() {
    const token = localStorage.getItem("accessToken");
    if (token) {
        return {
            authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
        };
    }
    return {}; // Return an empty object if there's no token
}

export default MultiPartApi;
